import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductDetailLayoutComponentsProviderComponentBase } from 'products-ui';

@Component({
  selector: 'ideal-standard-product-detail-layout-cart-components-provider',
  imports: [],
  standalone: true,
  templateUrl: './standard-product-detail-layout-cart-components-provider.component.html',
  styleUrl: './standard-product-detail-layout-cart-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardProductDetailLayoutCartComponentsProviderComponent extends ProductDetailLayoutComponentsProviderComponentBase {}
